import InteractiveAnnotation from "./interactiveAnnotation";
import { measureText, setBoxStyle } from "../canvasUtils";
import Circle from "./circle";

export default class CircleCollection extends InteractiveAnnotation {
  constructor(position, circleDefs, options) {
    super(position, options);

    let widestText = 0;
    let smallestRadius = Number.MAX_SAFE_INTEGER;
    let maxRadius = 0;
    let totalWidth = 0;
    for (let i = 0; i < circleDefs.length; i++) {
      let def = circleDefs[i];
      def.radius /= (2000 * this.scale);
      widestText = Math.max(measureText(def.text), widestText);
      smallestRadius = Math.min(def.radius, smallestRadius);
      maxRadius = Math.max(def.radius, maxRadius);
      totalWidth += def.radius * 2;
    }

    let circleSpacing = 25;
    if (widestText > smallestRadius)
      circleSpacing += (widestText - smallestRadius) / 2;

    this.circles = circleDefs.map((d, i) => {
      let xAdjustment = 0;
      if (i > 0) xAdjustment += circleDefs[0].radius + d.radius + i * circleSpacing;
      for (let j = 1; j < i; j++) xAdjustment += 2 * circleDefs[j].radius;
      return new Circle(position.x + xAdjustment, position.y + d.radius, d.radius, d.text, options);
    });

    this.circles.forEach(c => { 
      c.textSize = options.textSize;
      c.font = options.textSize + "px Calibri";
    });

    totalWidth += circleSpacing * (this.circles.length - 1);
    this.totalWidth = totalWidth;
    this.totalHeight = 30 + 2 * maxRadius;
  }

  draw(ctx) {
    this.circles.forEach(c => c.draw(ctx));
    if (this.circles.some(c => c.isActive)){
      setBoxStyle(ctx);
      ctx.beginPath();
      let circle = this.circles[0];
      ctx.strokeRect(circle.centerX - circle.radius - 10, 
        circle.centerY - circle.radius - 30 - 10, 
        this.totalWidth + 20, this.totalHeight + 20);
      ctx.closePath();
    }
  }

  isInBounds(x, y) { return this.circles.some(c => c.isInBounds(x, y)); }

  mousedown(x, y) {
    this.deactivate();
    this.circles.forEach(c => c.mousedown(x, y));
    this.signalReady();
  }

  mousemove(x, y) {
    this.circles.forEach(c => c.mousemove(x, y));
    this.signalReady();
  }

  deactivate(x, y) {
    this.circles.forEach(c => c.deactivate(x, y));
    this.signalReady();
  }

  setLineWidth(width) {
    this.circles.forEach(c => c.setLineWidth(width));
    this.signalReady();
  }

  updateTextSize(size) {
    this.circles.forEach(c => c.updateTextSize(size));
    this.signalReady();
  }

  updateColor(color) {
    this.circles.forEach(c => c.color = color);
    this.signalReady();
  }
}